import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import IndisSelectAuthContent from '@/components/tax-refund/individual/SelectAuth/IndisSelectAuthContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const IndisSelectAuthPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증타입선택, 'indis-selectauth_selectauth_cx');

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'indis-selectauth'} eventName={'indis-selectauth_selectauth'}>
        <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'indis-selectauth_topnav_back' } }} rightTextButton={rightInquiryButton}>
          <IndisSelectAuthContent />
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default IndisSelectAuthPage;
